//styles
import { styled } from '@nykaa/ui-components';

//components
import BaseButton from '@nykaa/ui-components/Button';

export const Button = styled(BaseButton)`
  border: ${({ theme }) => `1px solid ${theme.colors.textOutline}`};
  ${({ theme }) => theme.typography.buttonSmall};

  ${({ theme }) =>
    `padding: ${theme.spacing.spacing10} ${theme.spacing.spacing60};
     border-radius: ${theme.borders.radius10};
  `};

  i {
    border: none;
    padding: 0;
    margin-top: ${({ theme }) => theme.spacing.spacing20};
  }
`;
